<template>
  <commonTable
    class="mb-3"
    :fields="companyInformationTableFields"
    :items="
      add == true
        ? addCompanyInformationTableItems
        : companyInformationTableItems
    "
    :otherTheme="'tbody-green'"
    stickyHeader="230px"
  >
    <template #header>設備商資訊</template>
    <template #cell(companyName)="data">
      <template v-if="add == true || mod == true">
        <input
          type="text"
          class="form-control"
          :disabled="mod == true"
          v-model="addCompanyInformationTableItems[data.index].companyName"
          @blur="
            changeValue(
              'companyName',
              data.index,
              addCompanyInformationTableItems[data.index].companyName
            )
          "
        />
      </template>
      <template v-else>{{ data.value }}</template>
    </template>
    <template #cell(telephone)="data">
      <template v-if="add == true || mod == true">
        <input
          type="text"
          class="form-control"
          :disabled="add != true && mod != true"
          v-model="addCompanyInformationTableItems[data.index].telephone"
          @blur="
            changeValue(
              'telephone',
              data.index,
              addCompanyInformationTableItems[data.index].telephone
            )
          "
        />
      </template>
      <template v-else>{{ data.value }}</template>
    </template>
    <template #cell(fax)="data">
      <template v-if="add == true || mod == true">
        <input
          type="text"
          class="form-control"
          :disabled="add != true && mod != true"
          v-model="addCompanyInformationTableItems[data.index].fax"
          @blur="
            changeValue(
              'fax',
              data.index,
              addCompanyInformationTableItems[data.index].fax
            )
          "
        />
      </template>
      <template v-else>{{ data.value }}</template>
    </template>
    <template #cell(address)="data">
      <template v-if="add == true || mod == true">
        <input
          type="text"
          class="form-control"
          :disabled="add != true && mod != true"
          v-model="addCompanyInformationTableItems[data.index].address"
          @blur="
            changeValue(
              'address',
              data.index,
              addCompanyInformationTableItems[data.index].address
            )
          "
        />
      </template>
      <template v-else>{{ data.value }}</template>
    </template>
    <template #cell(category)="data">
      <template v-if="add == true || mod == true">
        <select
          class="form-select"
          :disabled="add != true && mod != true"
          v-model="addCompanyInformationTableItems[data.index].category"
          @blur="
            changeValue(
              'category',
              data.index,
              addCompanyInformationTableItems[data.index].category
            )
          "
        >
          <option v-for="item in firmCategory" :value="item.value">
            {{ item.text }}
          </option>
        </select>
      </template>
      <template v-else>{{ getCategoryText(data.value) }}</template>
    </template>
  </commonTable>
  <commonTable
    class="mb-3"
    :fields="equipmentVendorTableFields"
    :items="
      add == true || mod == true
        ? addEquipmentVendorTableItems
        : equipmentVendorTableItems
    "
    stickyHeader="350px"
  >
    <template #header>聯絡人資訊</template>
    <template #cell(contactPerson)="data">
      <template v-if="add == true || mod == true">
        <input
          type="text"
          class="form-control"
          :disabled="add != true && mod != true"
          v-model="addEquipmentVendorTableItems[data.index].contactPerson"
          @blur="
            changeValue(
              'contactPerson',
              data.index,
              addEquipmentVendorTableItems[data.index].contactPerson
            )
          "
        />
      </template>
      <template v-else>{{ data.value }}</template>
    </template>
    <template #cell(extension)="data">
      <template v-if="add == true || mod == true">
        <input
          type="text"
          class="form-control"
          :disabled="add != true && mod != true"
          v-model="addEquipmentVendorTableItems[data.index].extension"
          @blur="
            changeValue(
              'extension',
              data.index,
              addEquipmentVendorTableItems[data.index].extension
            )
          "
      /></template>
      <template v-else>{{ data.value }}</template>
    </template>
    <template #cell(phone)="data">
      <template v-if="add == true || mod == true">
        <input
          type="text"
          class="form-control"
          :disabled="add != true && mod != true"
          v-model="addEquipmentVendorTableItems[data.index].phone"
          @blur="
            changeValue(
              'phone',
              data.index,
              addEquipmentVendorTableItems[data.index].phone
            )
          "
      /></template>
      <template v-else>{{ data.value }}</template>
    </template>
    <template #cell(mail)="data">
      <template v-if="add == true || mod == true">
        <input
          type="email"
          class="form-control"
          :disabled="add != true && mod != true"
          v-model="addEquipmentVendorTableItems[data.index].mail"
          @blur="
            changeValue(
              'mail',
              data.index,
              addEquipmentVendorTableItems[data.index].mail
            )
          "
      /></template>
      <template v-else>{{ data.value }}</template>
    </template>
    <template #cell(note)="data">
      <template v-if="add == true || mod == true">
        <input
          type="text"
          class="form-control"
          :disabled="add != true && mod != true"
          v-model="addEquipmentVendorTableItems[data.index].note"
          @blur="
            changeValue(
              'note',
              data.index,
              addEquipmentVendorTableItems[data.index].note
            )
          "
      /></template>
      <template v-else>{{ data.value }}</template>
    </template>
    <template v-if="add == true || mod == true" #footer>
      <button
        type="button"
        class="btn p-0"
        style="
          color: #fff;
          background-color: #4b8c80;
          width: 6rem;
          height: 2rem;
          font-size: 1.125rem;
        "
        @click="addContactPerson"
      >
        新增聯絡人
      </button>
    </template>
  </commonTable>
  <div class="gap-2 d-md-flex justify-content-md-end">
    <template v-if="add == true">
      <button
        type="button"
        class="btn p-0 me-2"
        style="
          color: #fff;
          background-color: #4b8c80;
          width: 6rem;
          height: 2rem;
          font-size: 1.125rem;
        "
        @click="back"
      >
        取消
      </button>
      <button
        type="button"
        class="btn p-0"
        style="
          color: #fff;
          background-color: #4b8c80;
          width: 6rem;
          height: 2rem;
          font-size: 1.125rem;
        "
        @click="addCompanyCheck"
      >
        確認建檔
      </button>
    </template>
    <template v-else-if="mod == true">
      <button
        type="button"
        class="btn p-0 me-2"
        style="
          color: #fff;
          background-color: #4b8c80;
          width: 6rem;
          height: 2rem;
          font-size: 1.125rem;
        "
        @click="modCompanyCancel"
      >
        取消修改
      </button>
      <button
        type="button"
        class="btn p-0"
        style="
          color: #fff;
          background-color: #4b8c80;
          width: 6rem;
          height: 2rem;
          font-size: 1.125rem;
        "
        @click="modCompanyCheck"
      >
        確認修改
      </button>
    </template>
    <template v-else>
      <button
        type="button"
        class="btn p-0 me-2"
        style="
          color: #fff;
          background-color: #4b8c80;
          width: 6rem;
          height: 2rem;
          font-size: 1.125rem;
        "
        @click="back"
      >
        返回
      </button>
      <button
        type="button"
        class="btn p-0"
        style="
          color: #fff;
          background-color: #4b8c80;
          width: 6rem;
          height: 2rem;
          font-size: 1.125rem;
        "
        @click="modCompany"
      >
        進行修改
      </button>
    </template>
  </div>
</template>

<script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import commonTable from "@/components/commonTable.vue";
import { computed, inject, ref } from "vue";
import store from "@/store";
export default {
  components: { commonQueryInput, commonTable },
  setup() {
    const commonMethods = inject("commonMethods");
    const add = inject("add");
    const mod = inject("mod");
    const companyInformationTableFields = inject(
      "companyInformationTableFields"
    );
    const companyInformationTableItems = inject("companyInformationTableItems");
    const addCompanyInformationTableItems = inject(
      "addCompanyInformationTableItems"
    );
    const equipmentVendorTableFields = inject("equipmentVendorTableFields");
    const equipmentVendorTableItems = inject("equipmentVendorTableItems");
    const addEquipmentVendorTableItems = inject("addEquipmentVendorTableItems");

    const firmCategory = computed(
      () => store.getters["selectOptions/get_firmCategory"]
    );

    const getCategoryText = (value) => {
      const category = computed(() =>
        firmCategory.value.find((item) => item.value === value)
      );
      return category.value ? category.value.text : value;
    };

    const companyRowClick = commonMethods.companyRowClick;
    const addCompany = commonMethods.addCompany;
    const addCompanyCheck = commonMethods.addCompanyCheck;
    const modCompany = commonMethods.modCompany;
    const modCompanyCancel = commonMethods.modCompanyCancel;
    const modCompanyCheck = commonMethods.modCompanyCheck;
    const back = commonMethods.back;
    const addContactPerson = commonMethods.addContactPerson;
    const changeValue = commonMethods.changeValue;

    return {
      add,
      mod,
      companyInformationTableFields,
      companyInformationTableItems,
      addCompanyInformationTableItems,
      equipmentVendorTableFields,
      equipmentVendorTableItems,
      addEquipmentVendorTableItems,
      firmCategory,
      getCategoryText,
      companyRowClick,
      addCompany,
      addCompanyCheck,
      modCompany,
      modCompanyCancel,
      modCompanyCheck,
      back,
      addContactPerson,
      changeValue,
    };
  },
};
</script>

<style></style>
